import React from 'react';
import PropTypes from 'prop-types';

import styles from './style.scss';


const SeoLink = ({ url, text }) => {
  return (
    <div className={styles.link} onClick={() => window.open(url)}>
      {text}
    </div>
  );
};

SeoLink.proptypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default SeoLink;
